// extracted by mini-css-extract-plugin
export default {"root":"TabList_root__7tJaq"};